export const leSpecificHolidayTypes = [
  {
    leName: 'Limited Time LUX Exclusive',
    whiteLabelName: 'Limited Time Exclusive',
    slug: 'limited_time_lux_exclusive',
    whiteLabelLabel: 'Limited Time Exclusive',
  },
]
